const config = {
    build_number: '615786',
    build_timestamp: '2026-09-02T19:09:33.553Z',
    build_commit: 'e6a5230e09fa7f9b530b99c38ce5ffaba941178b',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
